import { Orientation } from "./Common"

export type otherThicknessType = -1
export const otherThickness = -1

export function typeOThicknessToLayers(thickness: number): {
  front: number
  rear: number
} {
  return {
    front: Math.ceil((thickness - 0.3) / 2),
    rear: Math.floor((thickness - 0.3) / 2),
  }
}

export function thicknessToString(
  glass: IGlass,
  thickness: IGlass["thickness"]
): string {
  if (thickness === otherThickness) return "Other"

  if (glass.isDouble)
    return `${typeOThicknessToLayers(thickness).front}+${
      typeOThicknessToLayers(thickness).rear
    }`

  return thickness.toString()
}

export interface IGlass {
  withGlass: boolean
  width: [number, number, number]
  height: [number, number, number]
  centralOffsetX: [number, number, number]
  centralOffsetY: [number, number, number]
  independentWH: boolean
  thickness: number | otherThicknessType // mm
  coverGlass: [number, number, number]
  isDouble: boolean
  orientation: Orientation
}
